import React from 'react';
import { ContextAppDto } from '../../dto/ContextAppDto';

const ContextApp = React.createContext(
  {} as ContextAppDto
);

export default ContextApp;